import AbstractStonecodeFileTypeModel from './AbstractStonecodeFileTypeModel';

export default class StonecodeFileTypeModel extends AbstractStonecodeFileTypeModel {}
